import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "relative-position" }
const _hoisted_2 = { class: "q-pa-md" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6 offset-md-3 col-xs-12 offset-xs-0" }
const _hoisted_5 = { class: "row q-pa-sm" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 col-xs-12" }, null, -1)
const _hoisted_7 = { class: "col-md-6 col-xs-12" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 col-xs-12" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_subject_card = _resolveComponent("subject-card")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_spinner_orbit = _resolveComponent("q-spinner-orbit")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_q_input, {
            standout: "bg-primary text-white",
            label: `Pesquisar Disciplinas (${_ctx.filteredTree ? _ctx.filteredTree.length : 0})`,
            clearable: "",
            modelValue: _ctx.searchSubjects,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchSubjects) = $event)),
            "data-cy": "material-filter"
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_q_icon, { name: "search" })
            ]),
            append: _withCtx(() => [
              _createVNode(_component_q_btn, {
                label: _ctx.orderOption.label,
                icon: "filter_list",
                flat: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_list, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderOptions, (order, o) => {
                            return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                              clickable: "",
                              onClick: ($event: any) => (_ctx.orderOption = order),
                              class: _normalizeClass(_ctx.orderOption === order ? "bg-primary text-white" : null)
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, { class: "text-uppercase" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(order.label), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick", "class"])), [
                              [_directive_ripple]
                            ])
                          }), 256))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["label", "modelValue"])
        ])
      ])
    ]),
    _createVNode(_component_q_separator),
    _createVNode(_component_q_scroll_area, { style: {"height":"calc(100vh - (50px + 89px))"} }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTree, (tree, s) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-md-12 col-xs-12 q-pa-sm",
                  key: s
                }, [
                  _createVNode(_component_subject_card, {
                    tree: tree,
                    index: s,
                    "data-cy": "subject-card"
                  }, null, 8, ["tree", "index"])
                ]))
              }), 128))
            ])
          ]),
          _hoisted_9
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_q_inner_loading, {
      showing: _ctx.loading,
      class: _normalizeClass(_ctx.$q.dark.isActive ? "bg-dark" : "bg-white")
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_spinner_orbit, {
          size: "4em",
          color: "primary",
          thickness: 2
        })
      ]),
      _: 1
    }, 8, ["showing", "class"])
  ]))
}